import { AppContext } from "../core/context";

export function createProgressBar(ctx: AppContext, module, entity) {

    var entityNode = ctx.scene.getTransformNodeByUniqueId(entity.uniqueId);
    var entityBounds = entityNode.getChildMeshes(true, function (m) { return m.id === "entitybounds"; })[0];

    var progressbg = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_progressbg");
    progressbg.width = "100px";
    progressbg.height = "12px";
    progressbg.color = "Gray";
    // progressbg.thickness = 2;
    progressbg.background = "Gray";
    progressbg.alpha = 0.6;

    var progresspct = new BABYLON.GUI.Rectangle(module.id + "_" + entity.id + "_progresspct");
    progresspct.width = "0px";
    progresspct.height = "12px";
    progresspct.color = "Gray";
    // progresspct.thickness = 2;
    progresspct.background = "Gray";

    ctx.GUI.addControl(progressbg);
    ctx.GUI.addControl(progresspct);

    progressbg.linkWithMesh(entityBounds);
    progresspct.linkWithMesh(entityBounds);

    return progressbg;
}

export function onProgress(ctx: AppContext, e: any) {

    let entity = ctx.moduleHelper.getEntityByID(ctx.currentModule, e.id);

    let progressbarBg = ctx.GUI.rootContainer.getChildByName(ctx.currentModule.id + "_" + entity.id + "_progressbg");
    if (!progressbarBg) {
        createProgressBar(ctx, ctx.currentModule, entity);
        progressbarBg = ctx.GUI.rootContainer.getChildByName(ctx.currentModule.id + "_" + entity.id + "_progressbg");
    }

    let progressbarPct = ctx.GUI.rootContainer.getChildByName(ctx.currentModule.id + "_" + entity.id + "_progresspct");
    if (progressbarPct) {
        progressbarPct.width = (e.received / e.total) * 100 + "px";
    }

    if (Math.round((e.received / e.total) * 100) === 100) {
        if (progressbarBg)
            progressbarBg.dispose();

        if (progressbarPct)
            progressbarPct.dispose();
    }
}
